<template>
  <div class="form-box">
    <h5>合作咨询</h5>
    <div class="from-contain">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="" prop="name">
          <el-input
            v-model="form.name"
            placeholder="您的名字(我们联系您时的尊称)"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="unit">
          <el-input v-model="form.unit" placeholder="您的单位名称"></el-input>
        </el-form-item>
        <el-form-item label="" prop="contact">
          <el-input
            v-model="form.contact"
            placeholder="您的联系方式(如QQ、电话等)"
          ></el-input>
        </el-form-item>
        <el-form-item label="" prop="email">
          <el-input v-model="form.email" placeholder="您的邮箱"></el-input>
        </el-form-item>
        <!-- <el-form-item label="" prop="region">
          <el-select v-model="form.region" placeholder="国内">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="city">
          <el-select v-model="form.city" placeholder="省份">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="" class="textarea-box" prop="message">
          <el-input
            type="textarea"
            v-model="form.message"
            placeholder="请简单描述合作详情"
          ></el-input>
        </el-form-item>
        <el-form-item class="btn-box">
          <el-button type="primary" @click="onSubmit('form')">提交</el-button>
        </el-form-item>
      </el-form>
      <div class="contact-box">
        <h6>联系我们</h6>
        <p class="phone-p">
          <img src="../assets/images/phone.png" alt="" />
          <span>400-810-8266</span>
        </p>
        <p class="email-p">
          <img src="../assets/images/email.png" alt="" />
          <a  href="mailto:info@chinalawinfo.com">info@chinalawinfo.com</a>
        </p>
        <p class="code-p">
          <img src="../assets/images/code.png" alt="" />
          <span>在线客服</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { sendEmailAndSMS } from "@/api/index";
export default {
  name: "Form",
  components: {},
  data() {
    return {
      form: {
        name: "",
        unit: "",
        contact: "",
        email: "",
        // region: "国内",
        // city: "",
        message: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入您的名字", trigger: "blur" },
          { min: 2, max: 4, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        unit: [
          {
            type: "string",
            required: true,
            message: "请输入您的单位名称",
            trigger: "blur",
          },
        ],
        contact: [
          {
            type: "string",
            required: true,
            message: "请输入您的联系方式",
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "string",
            required: true,
            message: "请输入您的邮箱",
            trigger: "blur",
          },
        ],
        // region: [
        //   { type: 'string', required: true, message: '请选择国家', trigger: 'change' }
        // ],
        // city: [
        //   { type: 'string', required: true, message: '请选择省份', trigger: 'change' }
        // ],
        message: [{ required: true, message: "请描述详情", trigger: "blur" }],
      },
    };
  },
  mounted() {},
  methods: {
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          sendEmailAndSMS(this.form)
            .then((res) => {
              this.$message({
                message: "您所填写的信息已提交!",
                type: "success",
              });
              for (let key in this.form) {
                this.form[key] = "";
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-box {
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  padding-top: 60px;
}
h5 {
  text-align: center;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #262626;
  line-height: 40px;
  margin-bottom: 60px;
}
.from-contain {
  width: 1200px;
  display: flex;
  justify-content: space-between;
}
/deep/.el-form {
  width: 840px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #dd3019;
  line-height: 40px;
}
/deep/.el-textarea__inner,
/deep/.el-input__inner {
  text-indent: 9px;
}
/deep/.el-input,
/deep/.el-form-item,
/deep/.el-input__inner {
  width: 410px;
  height: 52px;
  border-radius: 0px;
  margin-left: 0 !important;
}
/deep/.selected,
/deep/.el-select .el-input.is-focus .el-input__inner {
  color: #1867dd;
  border-color: #1867dd;
  border-radius: 0px;
}
.el-select-dropdown__item.selected {
  color: #1867dd !important;
}
/deep/.el-button,
/deep/.el-form-item__content {
  width: 128px;
  height: 42px;
  border-radius: 0px;
  margin: 0 auto !important;
}
/deep/.el-button {
  border-radius: 0px;
  background-color: #1867dd;
  border-color: #1867dd;
}
/deep/.el-textarea,
/deep/.el-textarea__inner,
.textarea-box /deep/.el-form-item__content,
.textarea-box {
  width: 840px;
  height: 165px;
}
.btn-box,
/deep/.el-form-item__content {
  width: 840px;
}
.btn-box button {
  margin-left: 356px !important;
}
/deep/.el-textarea__inner:focus,
/deep/.el-input__inner:focus {
  border-color: #1867dd;
}
/deep/.el-select .el-input.is-focus .el-input__inner,
/deep/.el-select .el-input__inner:focus {
  border-color: #1867dd;
}
/deep/.el-input:before,
/deep/.el-textarea:before {
  content: "*";
  color: #dd3019;
  font-size: 100%;
  position: absolute;
  left: 19px;
  top: 5px;
}
.el-textarea:before {
  top: -5px;
}
.textarea-box {
  margin-bottom: 39px;
}
/deep/.el-form-item__error {
  top: auto;
}
.contact-box {
  width: 300px;
  height: 200px;
  // background-color: #1867dd;
}
h6 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #262626;
  line-height: 34px;
  margin-bottom: 30px;
}
.phone-p span {
  display: inline-block;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #262626;
  line-height: 30px;
  margin-left: 10px;
}
.email-p{
  margin-right: 20px;
  border-radius: 15px;
  background: rgba($color: #1867dd, $alpha: 0.1);
}
.email-p a {
  display: inline-block;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1867dd;
  line-height: 30px;
  margin-left: 10px;
  text-decoration: none;
}
.phone-p,.email-p{
  display: flex;
  justify-content: flex-start;
  margin-bottom: 25px;
}
.phone-p img,.email-p img{
  width: 30px;
  height: 30px;
}
.code-p img{
  margin-bottom: 5px;
}
.code-p span{
  display: block;
  width: 110px;
  text-align: center;
}
</style>
